const inboundSMS = 'inboundSMS';

/** Base Fetch Actions */
export const FETCH_INBOUND_SMS_ERROR = `${inboundSMS}/FETCH_INBOUND_SMS_ERROR`;
export const FETCH_INBOUND_SMS_REQUEST = `${inboundSMS}/FETCH_INBOUND_SMS_REQUEST`;
export const FETCH_INBOUND_SMS_RESPONSE = `${inboundSMS}/FETCH_INBOUND_SMS_RESPONSE`;
